import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const API_BASE_URL = "http://dzsoftech.net/tours/api";

// Fallback data in case API is unavailable
const fallbackOffers = [
  {
    id: 1,
    title: "Himalay, Nepal",
    price: "$499.00 USD",
    image: "/assets/img/normal/offer_img_1.jpg",
  },
  {
    id: 2,
    title: "Ashi Lake Hakone, Japan",
    price: "$465.11",
    image: "/assets/img/normal/offer_img_2.jpg",
  },
  {
    id: 3,
    title: "Coxbazar, Bangladesh",
    price: "8,200 tk",
    image: "/assets/img/normal/offer_img_3.jpg",
  },
  {
    id: 4,
    title: "Architecture in Paris",
    price: "$437.29",
    image: "/assets/img/normal/offer_img_4.jpg",
  },
  {
    id: 5,
    title: "Caribbean, Maldives",
    price: "$2,333",
    image: "/assets/img/normal/offer_img_5.jpg",
  },
];

const OfferOne = () => {
  const [activeIndex, setActiveIndex] = useState(1);
  const [hoveredIndex, setHoveredIndex] = useState(1);
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [nextExpiringOffer, setNextExpiringOffer] = useState(null);

  // Fetch offers from API
  const fetchOffers = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/tour/offers/featured/`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch offers');
      }
      
      const data = await response.json();
      
      if (data && data.length > 0) {
        // Transform API data to match component expectations
        const transformedOffers = data.map((offer, index) => ({
          id: offer.id,
          title: offer.main_title || offer.title,
          price: `$${offer.price}`,
          discount: offer.discount_percentage,
          originalPrice: `$${offer.original_price}`,
          image: offer.image_url || `/assets/img/normal/offer_img_${(index % 5) + 1}.jpg`,
          description: offer.description,
          buttonText: offer.button_text || 'Book Now',
          buttonLink: offer.button_link || '/contact',
          expiresAt: offer.offer_expires_at,
          timeRemaining: offer.time_remaining,
          isExpired: offer.is_expired
        }));
        
        setOffers(transformedOffers);
        
        // Find the next expiring offer for countdown
        const activeOffers = transformedOffers.filter(offer => !offer.isExpired);
        if (activeOffers.length > 0) {
          // Sort by expiration date and get the soonest
          const sortedOffers = activeOffers.sort((a, b) => 
            new Date(a.expiresAt) - new Date(b.expiresAt)
          );
          setNextExpiringOffer(sortedOffers[0]);
        }
      } else {
        // Use fallback data if API returns empty
        setOffers(fallbackOffers);
      }
    } catch (error) {
      console.error('Error fetching offers:', error);
      // Use fallback data in case of error
      setOffers(fallbackOffers);
    } finally {
      setLoading(false);
    }
  };

  // Update countdown timer
  const updateCountdown = () => {
    if (!nextExpiringOffer || !nextExpiringOffer.expiresAt) return;
    
    const now = new Date().getTime();
    const expiryTime = new Date(nextExpiringOffer.expiresAt).getTime();
    const timeDiff = expiryTime - now;
    
    if (timeDiff > 0) {
      const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
      
      setCountdown({ days, hours, minutes, seconds });
    } else {
      setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    }
  };

  const handleMouseEnter = (id) => {
    setHoveredIndex(id);
  };
  
  const handleMouseLeave = () => {
    setHoveredIndex(offers.length > 0 ? offers[0].id : 1);
  };

  useEffect(() => {
    fetchOffers();
  }, []);

  useEffect(() => {
    if (offers.length > 0) {
      setActiveIndex(offers[0].id);
      setHoveredIndex(offers[0].id);
    }
  }, [offers]);

  useEffect(() => {
    // Update countdown every second
    const timer = setInterval(updateCountdown, 1000);
    updateCountdown(); // Initial call
    
    return () => clearInterval(timer);
  }, [nextExpiringOffer]);

  return (
    <section className="position-relative overflow-hidden space">
      <div className="container shape-mockup-wrap">
        <div className="offer-deals-accordion">
          <div className="row">
            {/* Left Column */}
            <div className="col-xl-7">
              <div className="offer-deals-wrapp">
                <div className="accordion-item-wrapp" id="offerDeals">
                  {offers.map((offer, index) => (
                    <div
                      key={offer.id}
                      className={`accordion-item-content ${activeIndex === offer.id ? "active" : ""
                        }`}
                      onMouseEnter={() => handleMouseEnter(offer.id)}
                      onMouseLeave={handleMouseLeave}
                    >
                      <div className="accordion-tab-item" data-bs-toggle="tab" data-bs-target={`#tab${offer.id}`}>
                        <div className="accordion-item">
                          <div className="accordion-header" id={`collapse-item-${offer.id}`}>
                            <button
                              className={`accordion-button ${activeIndex === offer.id ? "" : "collapsed"}`}
                              aria-expanded={activeIndex === offer.id}
                              aria-controls={`collapse-${offer.id}`}
                              onClick={() => setActiveIndex(activeIndex === offer.id ? null : offer.id)}
                            >
                              <span className="accordion-item_info">
                                <span className="box-title">{offer.title}</span>
                                <i className="fa-thin fa-angle-down" />
                              </span>
                            </button>
                          </div>
                          <div
                            id={`collapse-${offer.id}`}
                            className="accordion-collapse"
                            style={{
                              maxHeight: activeIndex === offer.id ? "max-content" : "0px",
                              overflow: "hidden",
                              transition: "max-height 0.4s ease-in-out",
                            }}
                            aria-labelledby={`collapse-item-${offer.id}`}
                          >
                            <div className="accordion-body">
                              <span className="faq-price">{offer.price}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Tab Content Images */}
                <div id="tabs-content">
                  {offers.map((offer) => (
                    <div
                      key={offer.id}
                      id={`tab${offer.id}`}
                      className={`according-img-tab ${hoveredIndex !== null && hoveredIndex !== offer.id ? "d-none" : ""}`}
                    >
                      <img src={offer.image} alt={offer.title} />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-xl-5">
              <div className="title-area pe-xl-5 me-xl-5">
                <span className="sub-title">Last Discount for you</span>
                <h2 className="sec-title">Offer Deals & Discount</h2>
              </div>
              {loading ? (
                <div className="text-center mb-4">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading offers...</span>
                  </div>
                </div>
              ) : (
                <>
                  <ul className="offer-deals-counter counter-list">
                    <li>
                      <div className="day count-number">{String(countdown.days).padStart(2, '0')}</div>
                      <span className="count-name">Days</span>
                    </li>
                    <li>
                      <div className="hour count-number">{String(countdown.hours).padStart(2, '0')}</div>
                      <span className="count-name">Hours</span>
                    </li>
                    <li>
                      <div className="minute count-number">{String(countdown.minutes).padStart(2, '0')}</div>
                      <span className="count-name">Minutes</span>
                    </li>
                    <li>
                      <div className="seconds count-number">{String(countdown.seconds).padStart(2, '0')}</div>
                      <span className="count-name">Seconds</span>
                    </li>
                  </ul>
                  {nextExpiringOffer && (
                    <div className="mb-3">
                      <small className="text-muted">
                        Next offer expires: {nextExpiringOffer.title}
                      </small>
                    </div>
                  )}
                </>
              )}
              <div className="mt-60">
                <Link to="/contact" className="th-btn style3 th-icon">
                  Get More Offer
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Shape Mockup */}
        <div className="shape-mockup movingX d-none d-xl-block" style={{bottom:"-8%", left: "-15%"}}>
          <img src="/assets/img/shape/shape_2_1.png" alt="shape" />
        </div>
      </div>
    </section>
  );
};

export default OfferOne;
